import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { separationReasonOptions } from '../../../../utils/labels';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-separation-reason-title']),
    separationDueToAssignedReasons: radioUI({
      title: content['household-separation-reason-question'],
      labels: separationReasonOptions,
    }),
  },
  schema: {
    type: 'object',
    required: ['separationDueToAssignedReasons'],
    properties: {
      separationDueToAssignedReasons: radioSchema(
        Object.keys(separationReasonOptions),
      ),
    },
  },
};
